import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";

import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import BajaMultiple from "../../BajaMultiple";
import StatusMultiple from "../../StatusMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import moment from 'moment';
import { v4 as uuidv4 } from "uuid";
import AutorizadoMultiple from "../../AutorizadoMultiple";
import fmtFecha from "../../../../utils/fmtFecha";

function ListadoVentasTiendas() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_VENTAS_TIENDAS = import.meta.env.VITE_URL_VENTAS_TIENDAS;
  const URL_ABONOS_TIENDAS = import.meta.env.VITE_URL_ABONOS_TIENDAS;
  const URL_CLIENTES = import.meta.env.VITE_URL_CLIENTES;
  const URL_COLABORADORES = import.meta.env.VITE_URL_COLABORADORES;
  const URL_SEND_MAIL_ATT = import.meta.env.VITE_URL_SEND_MAIL_ATT;
  const URL_ARTICULOS_VENTAS_TIENDAS = import.meta.env.VITE_URL_ARTICULOS_VENTAS_TIENDAS;
  const URL_AREAS = import.meta.env.VITE_URL_AREAS;
  const URL_WHATSAPP = import.meta.env.VITE_URL_WHATSAPP;

  let date = new Date()
  let hoy = moment(date).format("YYYY-MM-DD"); 

  const [ventasTiendas, setVentasTiendas] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [paqueteria, setPaqueteria] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(hoy);
  const [selectedFechaFin, setSelectedFechaFin] = useState(hoy);
  const [fecha, setFecha] = useState("");
  const [total_general, setTotalGeneral] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [comisionTDC, setComisionTDC] = useState(0);
  const [comisionFlete, setComisionFlete] = useState(0);
  const [iva, setIva] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  
  const [areas, setAreas] = useState([]);
  const [selectedAreaFiltro, setSelectedAreaFiltro] = useState("");
  const [efectivo, setEfectivo] = useState(0);
  const [tdc, setTDC] = useState(0);
  const [transferencia, setTransferencia] = useState(0);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");


  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(()=>{
    setSelectedArea(user.areas)
    if(user.areas){
    if(user.areaEsTienda == "Si" ){
    axios
      .get(`${URL_VENTAS_TIENDAS}VentasDiario/${user.areas}/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allVentas = response.data;
        // Array para pagination
        let arrayTabla = allVentas
          .sort((a, b) => (a.idVentaTienda > b.idVentaTienda ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              numero: a.idVentaTienda,
              consecutivo: a.prefijo + a.consecutivo,
              activo: a.is_active,
              fecha: a.fecha,
              fechaHora: a.fecha + " " + moment(a.createdAt).utcOffset('-0600').format("HH:mm:ss"),
              colaborador: a.colaboradores[0].nombre + " " + a.colaboradores[0].apellido,
              idColaborador: a.colaboradores[0]._id,
              observaciones: a.observaciones,
              subTotal: a.subTotal,
              iva: a.iva,
              total_general: a.total_general,
              clientes: a.clientes[0].nombre_comercial,
              idClientes: a.clientes[0]._id,
              total_cantidad: a.total_cantidad,
              comisionTDC: a.comisionTDC,
              comisionFlete: a.comisionFlete,
              impuestos: a.impuestos,
              calle: a.clientes[0].calle,
              numero_ext: a.clientes[0].numero_ext,
              numero_int: a.clientes[0].numero_int,
              pais: a.clientes[0].pais,
              estado: a.clientes[0].estado,
              ciudad: a.clientes[0].ciudad,
              delegacion: a.clientes[0].delegacion,
              colonia: a.clientes[0].colonia,
              cp: a.clientes[0].cp,
              paqueteria: a.clientes[0].paqueteria,
              idAreas: a.areas[0]._id,
              area: a.areas[0].name,
              areaSurtido: a.areaSurtido[0].name,
              condPago: a.cond_pago,
              entregado:a.entregado,
              descuento:a.descuento,
              descuentoNumero: (parseFloat(a.subTotal) * parseFloat(a.descuento))/100,
              facturado:a.facturado
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let data = Object.values(arrayTabla);
        
        setVentasTiendas(data);
        setComments(data);
        //
      })
      .catch((err) => {
        console.log(err);
      })} else{
        axios
          .get(`${URL_VENTAS_TIENDAS}VentasDiarioGeneral/${selectedFechaInicio}/${selectedFechaFin}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((response) => {
            let allVentas = response.data;
            // Array para pagination
            let arrayTabla = allVentas
              .sort((a, b) => (a.idVentaTienda > b.idVentaTienda ? 1 : -1))
              .map((a) => {
                return {
                  _id: a._id,
                  numero: a.idVentaTienda,
                  consecutivo: a.prefijo + "-" + a.consecutivo,
                  activo: a.is_active,
                  fecha: a.fecha,
                  fechaHora: a.fecha + " " + moment(a.createdAt).utcOffset('-0600').format("HH:mm:ss"),
                  colaborador: a.colaboradores[0].nombre + " " + a.colaboradores[0].apellido,
                  idColaborador: a.colaboradores[0]._id,
                  observaciones: a.observaciones,
                  subTotal: a.subTotal,
                  iva: a.iva,
                  total_general: a.total_general,
                  clientes: a.clientes[0].nombre_comercial,
                  idClientes: a.clientes[0]._id,
                  total_cantidad: a.total_cantidad,
                  comisionTDC: a.comisionTDC,
                  comisionFlete: a.comisionFlete,
                  impuestos: a.impuestos,
                  calle: a.clientes[0].calle,
                  numero_ext: a.clientes[0].numero_ext,
                  numero_int: a.clientes[0].numero_int,
                  pais: a.clientes[0].pais,
                  estado: a.clientes[0].estado,
                  ciudad: a.clientes[0].ciudad,
                  delegacion: a.clientes[0].delegacion,
                  colonia: a.clientes[0].colonia,
                  cp: a.clientes[0].cp,
                  paqueteria: a.paqueterias[0].name,
                  idPaqueteria: a.paqueterias[0]._id,
                  idAreas: a.areas[0]._id,
                  area: a.areas[0].name,
                  areaSurtido: a.areaSurtido[0].name,
                  condPago: a.cond_pago,
                  entregado:a.entregado,
                  descuento:a.descuento,
                  descuentoNumero: (parseFloat(a.subTotal) * parseFloat(a.descuento))/100,
              facturado:a.facturado
                }
              })
              .filter(function (el) {
                return el != null;
              });
    
            let data = Object.values(arrayTabla);

            setVentasTiendas(data);
            setComments(data);
            //
          })
          .catch((err) => {
            console.log(err);
          })}
        }

          axios
          .get(URL_AREAS, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((res) => {
            const allAreas = res.data;
            setAreas(allAreas);
          })
          .catch((err) => {
            console.log(err);
          });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });

  }, [user, selectedFechaInicio, selectedFechaFin]);


  // Mismos filtros que la tabla en pantalla, incluido el buscador, para que
  // el PDF, el Excel y el eMail siempre coincidan con lo que se esta viendo.
  function coincideFiltros(a) {
    const pasaSelectores =
      (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
      (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
      (selectedCliente == 0 || selectedCliente == a.idClientes) &&
      (selectedColaborador == 0 || selectedColaborador == a.idColaborador) &&
      (selectedAreaFiltro == 0 || selectedAreaFiltro == a.idAreas);

    if (!pasaSelectores) return false;
    if (!search) return true;

    const texto = search.toLowerCase();
    return (
      a.clientes.toLowerCase().includes(texto) ||
      a.area.toLowerCase().includes(texto) ||
      a.facturado.toLowerCase().includes(texto) ||
      a.total_cantidad.toString().includes(search) ||
      a.total_general.toString().includes(search) ||
      a.consecutivo.toString().includes(search) ||
      a.numero.toString().includes(search) ||
      a.condPago.toLowerCase().includes(texto)
    );
  }

  function PDFTabla() {
    let TotalTabla = 0
    let TotalPiezas = 0
    const data = comments.map((a) => {
      if (coincideFiltros(a)) {
        TotalTabla = TotalTabla + (parseFloat(a.total_general) || 0)
        TotalPiezas = TotalPiezas + (parseFloat(a.total_cantidad) || 0)
        return [
          a.consecutivo,
          a.area,
          a.fecha,
          a.colaborador,
          a.clientes,
          a.total_cantidad,
          a.condPago,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general),
        ];
      }
    });

    const dataPDF = Object.values(data);

    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });

    const anchoHoja = 10; // ancho de ticket, no se toca
    const centerX = 5; // Center of 10cm width
    const leftMargin = 0.3;
    const rightMargin = 9.7;
    const inicioTabla = 3.9; // debe coincidir con el yPos final del encabezado
    const altoMaximo = 200; // pasando de aqui conviene paginar en vez de una sola tira
    const footerHeight = 1.6; // separador + leyenda de cierre
    const bufferHeight = 1; // holgura para el corte

    // Las columnas de texto (Area, Vendedor, Cliente) van sin cellWidth a
    // proposito: asi autoTable les reparte el ancho sobrante y la tabla nunca
    // puede rebasar los 9.4 cm utiles. Si se les pone ancho fijo, la libreria
    // ya no puede encogerlas y la ultima columna se sale de la hoja.
    const opcionesTabla = (startY) => ({
      head: [
        [
          "Numero",
          "Area",
          "Fecha",
          "Vendedor",
          "Cliente",
          "Cantidad",
          "Cond Pago",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: startY,

      columnStyles: {
        0: { cellWidth: 1.0, halign: "center", fontSize: 6 }, // Numero
        1: { halign: "left", fontSize: 6 }, // Area
        2: { cellWidth: 1.05, halign: "center", fontSize: 5.5 }, // Fecha
        3: { halign: "left", fontSize: 6 }, // Vendedor
        4: { halign: "left", fontSize: 6 }, // Cliente
        5: { cellWidth: 0.75, halign: "center", fontSize: 6 }, // Cantidad
        6: { cellWidth: 0.9, halign: "center", fontSize: 5.5 }, // Cond Pago
        7: { cellWidth: 1.5, halign: "right", fontSize: 6 }, // Total
      },

      styles: {
        fontSize: 6,
        font: "helvetica",
        cellPadding: { top: 0.08, right: 0.05, bottom: 0.08, left: 0.05 },
        lineWidth: 0.01,
        lineColor: [180, 180, 180],
        textColor: [0, 0, 0],
        overflow: "linebreak",
      },

      headStyles: {
        fontStyle: "bold",
        fontSize: 7,
        fillColor: [245, 245, 245],
        textColor: [0, 0, 0],
        halign: "center",
        cellPadding: { top: 0.15, right: 0.05, bottom: 0.15, left: 0.05 },
      },

      foot: [
        [
          "",
          "",
          "",
          "",
          { content: "TOTALES", styles: { fontStyle: "bold", halign: "center" } },
          { content: new Intl.NumberFormat("en-US").format(TotalPiezas), styles: { fontStyle: "bold", halign: "center" } },
          "",
          { content: new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(TotalTabla), styles: { fontStyle: "bold", halign: "right" } },
        ]
      ],
      showFoot: "lastPage",

      footStyles: {
        fontStyle: "bold",
        fontSize: 6,
        fillColor: [230, 230, 230],
        textColor: [0, 0, 0],
        cellPadding: { top: 0.15, right: 0.05, bottom: 0.15, left: 0.05 },
      },

      margin: { left: leftMargin, right: leftMargin, top: 0.5, bottom: 0.5 },
      theme: "grid",
    });

    // El alto de cada renglon depende de cuantas lineas ocupen los nombres
    // largos, asi que se mide la tabla en un documento borrador en lugar de
    // estimarla; si se desborda del alto maximo se deja paginar.
    const borrador = new jsPDF("p", "cm", [anchoHoja, altoMaximo], true);
    borrador.autoTable(opcionesTabla(inicioTabla));

    const totalHeight =
      borrador.getNumberOfPages() > 1
        ? altoMaximo
        : borrador.lastAutoTable.finalY + footerHeight + bufferHeight;

    // Create PDF with thermal receipt style but wider for table data
    const doc = new jsPDF("p", "cm", [anchoHoja, Math.max(totalHeight, 15)], true);

    var img2 = new Image();
    img2.src = "logoInstitucion.png";

    // HEADER SECTION with yPos tracking
    let yPos = 0.3; // Start position

    // Logo
    doc.addImage(img2, "png", 8.5, yPos, 1.2, 0.8);
    yPos += 1.0; // Space after logo

    // Business information - centered with better spacing
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text(`${import.meta.env.VITE_NOMBRE_INSTITUCION}`, centerX, yPos, {
      align: "center",
    });
    yPos += 0.6; // More space after business name

    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("LISTADO DE VENTAS", centerX, yPos, {
      align: "center",
    });
    yPos += 0.5;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text(`Periodo: ${selectedFechaInicio} - ${selectedFechaFin}`, centerX, yPos, {
      align: "center",
    });
    yPos += 0.5;

    doc.text(`Tienda: ${user.areaName}`, centerX, yPos, {
      align: "center",
    });
    yPos += 0.5; // More space before separator

    // Separator line
    doc.setLineWidth(0.01);
    doc.line(leftMargin, yPos, rightMargin, yPos);
    yPos += 0.5; // More space after separator

    // TABLE with improved styling
    doc.autoTable(opcionesTabla(yPos));

    // Get the Y position after the table
    yPos = doc.lastAutoTable.finalY + 0.5;

    // Footer separator
    doc.setLineWidth(0.01);
    doc.line(leftMargin, yPos, rightMargin, yPos);
    yPos += 0.3;

    // Footer information
    doc.setFont("helvetica", "normal");
    doc.setFontSize(6);
    doc.text("¡Gracias por confiar en nosotros!", centerX, yPos, {
      align: "center",
    });
    yPos += 0.25;
    doc.text("Conserve este reporte", centerX, yPos, {
      align: "center",
    });

    // Save and print
    doc.autoPrint();
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (coincideFiltros(a)) {
        return {
          Numero: a.consecutivo,
          Area: a.area,
          Fecha: a.fecha,
          Vendedor: a.colaborador,
          Cliente: a.clientes,
          Cantidad: a.total_cantidad,
          CondPago: a.condPago,
          Total: a.total_general,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoVentas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoVentas",
        sheetFilter: [
          "Numero",
          "Area",
          "Fecha",
          "Vendedor",
          "Cliente",
          "Cantidad",
          "CondPago",
          "Total",
        ],
        sheetHeader: [
          "Numero",
          "Area",
          "Fecha",
          "Vendedor",
          "Cliente",
          "Cantidad",
          "CondPago",
          "Total",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let TotalTabla = 0
    let TotalPiezas = 0
    const data = comments.map((a) => {
      if (coincideFiltros(a)) {
        TotalTabla = TotalTabla + (parseFloat(a.total_general) || 0)
        TotalPiezas = TotalPiezas + (parseFloat(a.total_cantidad) || 0)
        return [
          a.consecutivo,
          a.area,
          a.fecha,
          a.colaborador,
          a.clientes,
          a.total_cantidad,
          a.condPago,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general),
        ];
      }
    });

    const dataPDF = Object.values(data);

    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });


    const doc = new jsPDF("landscape","mm", "a4", true);
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 38, 18);
    doc.text(`Listado Ventas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Area",
          "Fecha",
          "Vendedor",
          "Cliente",
          "Cantidad",
          "Cond Pago",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US").format(TotalPiezas),
          "",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(TotalTabla),
        ]
      ]
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Ventas",
          email: mailTo,
          fileName: "ListadoVentas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${import.meta.env.VITE_TAMANO_LOGO_MAIL}" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${import.meta.env.VITE_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Ventas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${import.meta.env.VITE_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://sistemify.com"> <img width="20%" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}Logo-Sistemify-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

 

  async function PDFOC(
    fecha,
    fechaHora,
    colaborador,
    clientes,
    consecutivo,
    idPDFOC,
    comisionTDC,
    comisionFlete,
    impuestos,
    areaSurtido,
    descuento,
    descuentoNumero,
    condPago,
    idAreas,
  ) {
    try {
      const articlesResponse = await axios.get(`${URL_ARTICULOS_VENTAS_TIENDAS}/ventasTiendas/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });

      let allArticulosVenta = articlesResponse.data;
      let arrayTabla = allArticulosVenta
        .map((a) => {
          return {
            idArticulo: a.articulos[0]._id,
            articulos: a.articulos[0].codigo + " - " + a.articulos[0].nombre,
            colorNombre: a.colores && a.colores.length > 0 ? a.colores[0].name : "",
            tallaNombre: a.tallas && a.tallas.length > 0 ? a.tallas[0].name : "",
            cantidad: a.cantidad,
            precio: a.precio,
            total: a.total,
            cajas: a.cantidad / a.articulos[0].piezasPorCaja
          };
        })
        .filter(function (el) {
          return el != null;
        });

      let dataFinal = Object.values(arrayTabla);

      let agrupado = dataFinal.reduce(function (groups, item) {
        const val = item["idArticulo"]
        groups[val] = groups[val] || {
          idArticulo: item.idArticulo,
          cantidad: 0,
          total: 0,
          cajas: 0,
        };
        groups[val].cantidad += item.cantidad;
        groups[val].articulos = item.articulos;
        groups[val].colorNombre = item.colorNombre;
        groups[val].tallaNombre = item.tallaNombre;
        groups[val].precio = item.precio;
        groups[val].total += item.total;
        groups[val].cajas += item.cajas;
        return groups;
      },[])

      let dataAgrupado = Object.values(agrupado)

      // Get payment information
      const abonosResponse = await axios.get(`${URL_ABONOS_TIENDAS}/ventasTiendas/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });

      let allAbonosVenta = abonosResponse.data;
      let efectivoTotal = 0;
      let tdcTotal = 0;
      let transferTotal = 0;

      allAbonosVenta.forEach((abono) => {
        efectivoTotal += parseFloat(abono.efectivo || 0);
        tdcTotal += parseFloat(abono.tdc || 0);
        transferTotal += parseFloat(abono.transfer || 0);
      });

      let totalKG = dataAgrupado.map((c) => parseFloat(c.cantidad));
      let TK = totalKG.reduce((t, total, index) => t + total, 0);

      let importes = dataAgrupado.map((c) => parseFloat(c.total));
      let TG = importes.reduce((t, total, index) => t + total, 0);

      let cajas = dataAgrupado.map((c) => parseFloat(c.cajas));
      let TC = cajas.reduce((t, total, index) => t + total, 0);

      let totalParcial = 0;
      let subTotalTabla = 0
      let total_general_tabla = 0
      let iva_tabla = 0
      let impuesto_tabla = impuestos

      // Process data for table - truncate long names and format properly
      const data = dataAgrupado
        .sort((a, b) => (a.articulos > b.articulos ? 1 : -1))
        .map((a) => {
          totalParcial = a.cantidad * a.precio;
          subTotalTabla = subTotalTabla + totalParcial;

          // Truncate item name if too long (max 24 chars for 8cm width)
          const itemName = a.articulos.length > 24
            ? a.articulos.substring(0, 21) + "..."
            : a.articulos;

          return [
            itemName,
            a.colorNombre || "",
            a.tallaNombre || "",
            a.cantidad.toString(),
            `$${a.precio.toFixed(2)}`,
            `$${a.total.toFixed(2)}`,
          ];
        });

      const dataPDF = Object.values(data);
      const dataPDFLimpia = dataPDF.filter(function (el) {
        return el != null;
      });

      iva_tabla = subTotalTabla * impuesto_tabla/100
      total_general_tabla = subTotalTabla + comisionTDC + comisionFlete + iva_tabla

      // Calculate dynamic height based on content
      const baseHeight = 18; // Base height in cm
      const itemHeight = 0.5; // Height per item in cm
      const headerHeight = 8; // Height for header section
      const footerHeight = 12; // Height for footer, totals, payments
      const bufferHeight = 4; // Extra space at the end for cutting

      const totalHeight =
        headerHeight +
        dataPDFLimpia.length * itemHeight +
        footerHeight +
        bufferHeight;

      // Create PDF with proper thermal dimensions (8cm width) and calculated height
      const doc = new jsPDF("p", "cm", [8, totalHeight], true);

      // Generate QR code
      var base64 = await qrcode.toDataURL(idPDFOC);
      var img3 = new Image();
      img3.src = base64;

      var img2 = new Image();
      img2.src = "logoInstitucion.png";

      // HEADER SECTION with yPos tracking
      const centerX = 4; // Center of 8cm width
      const leftMargin = 0.2;
      const rightMargin = 7.8;
      let yPos = 0.3; // Start position

      // Logo
      doc.addImage(img2, "png", 6.5, yPos, 1.2, 0.8);
      yPos += 1.0; // Space after logo

      // Business information - centered with better spacing
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text(`${import.meta.env.VITE_NOMBRE_INSTITUCION}`, centerX, yPos, {
        align: "center",
      });
      yPos += 0.5; // More space after business name

      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text("CALLE ##, COLONIA", centerX, yPos, {
        align: "center",
      });
      yPos += 0.35; // More space between address lines

      doc.text("CIUDAD, ESTADO CP", centerX, yPos, {
        align: "center",
      });
      yPos += 0.35; // More space between address lines

      doc.text(`RFC:`, centerX, yPos, { align: "center" });
      yPos += 0.35; // More space after RFC

      doc.text("General de Ley de Personas Morales", centerX, yPos, {
        align: "center",
      });
      yPos += 0.5; // More space before separator

      // Separator line
      doc.setLineWidth(0.01);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.5; // More space after separator

      // Store information with better spacing
      doc.setFontSize(8);
      doc.text(`Tienda: ${user.areaName}`, centerX, yPos, {
        align: "center",
      });
      yPos += 0.35; // More space between store info lines

      doc.text(`Direccion: ${user.areaDireccion}`, centerX, yPos, {
        align: "center",
      });
      yPos += 0.35; // More space between store info lines

      doc.text(`Telefono: ${user.areaTelefono}`, centerX, yPos, {
        align: "center",
      });
      yPos += 0.5; // More space before separator

      // Another separator
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.5; // More space after separator

      // Transaction information with better spacing
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(`Fecha: ${fechaHora}`, centerX, yPos, { align: "center" });
      yPos += 0.4; // More space after date

      doc.setFont("helvetica", "normal");
      doc.text(
        `Nota: ${consecutivo} / Almacen: ${areaSurtido}`,
        centerX,
        yPos,
        { align: "center" }
      );
      yPos += 0.5; // More space before customer info

      // Customer and seller info with better spacing
      doc.text(`Cliente: ${clientes}`, leftMargin, yPos);
      yPos += 0.35; // More space between customer and seller

      doc.text(`Vendedor: ${colaborador}`, leftMargin, yPos);
      yPos += 0.6; // Much more space before final separator

      // Final separator before items
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.6; // Much more space before table starts
      // ITEMS TABLE with proper column widths for 8cm (6 columns)
      doc.autoTable({
        head: [["Articulo", "Color", "Talla", "Can", "Precio", "Total"]],
        body: dataPDFLimpia,
        startY: yPos, // Use yPos instead of fixed value

        // Fixed column widths that total to ~7.6cm (leaving margins) - 6 columns
        columnStyles: {
          0: {
            cellWidth: 2, // Item name (largest)
            halign: "left",
            overflow: "linebreak",
            fontSize: 7,
          },
          1: {
            cellWidth: 1, // Color
            halign: "left",
            overflow: "hidden",
            fontSize: 7,
          },
          2: {
            cellWidth: 1, // Talla
            halign: "left",
            overflow: "hidden",
            fontSize: 7,
          },
          3: {
            cellWidth: 0.8, // Cantidad
            halign: "center",
            overflow: "hidden",
            fontSize: 7,
          },
          4: {
            cellWidth: 1.3, // Precio
            halign: "right",
            overflow: "linebreak",
            fontSize: 6,
          },
          5: {
            cellWidth: 1.5, // Total
            halign: "right",
            overflow: "linebreak",
            fontSize: 6,
          },
        },

        styles: {
          fontSize: 8,
          font: "helvetica",
          cellPadding: { top: 0.2, right: 0.1, bottom: 0.2, left: 0.1 }, // More vertical padding
          lineWidth: 0.01,
          lineColor: [180, 180, 180],
          textColor: [0, 0, 0],
          overflow: "linebreak",
        },

        headStyles: {
          fontStyle: "bold",
          fontSize: 9,
          fillColor: [245, 245, 245],
          textColor: [0, 0, 0],
          halign: "center",
          cellPadding: { top: 0.25, right: 0.1, bottom: 0.25, left: 0.1 }, // More padding in header
        },

        margin: { left: leftMargin, right: leftMargin },
        tableWidth: "wrap",
        theme: "grid",
      });

      // Get the Y position after the table with much more space
      yPos = doc.lastAutoTable.finalY + 0.8; // Much more space after table

      // TOTALS SECTION
      doc.setLineWidth(0.02);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.4; // More space after line

      // Subtotal, discount, total with better spacing and simpler formatting
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);

      const totalsX = 3.8; // Move labels more to the left for better spacing

      doc.text("SubTotal:", totalsX, yPos);
      doc.text(`$${subTotalTabla.toFixed(2)}`, rightMargin - 0.1, yPos, {
        align: "right",
      });
      yPos += 0.35; // More space between lines

      if (descuentoNumero > 0) {
        doc.text(`Descuento ${descuento}%:`, totalsX, yPos);
        doc.text(`$${descuentoNumero.toFixed(2)}`, rightMargin - 0.1, yPos, {
          align: "right",
        });
        yPos += 0.35;
      }

      if (iva_tabla > 0) {
        doc.text("IVA:", totalsX, yPos);
        doc.text(`$${iva_tabla.toFixed(2)}`, rightMargin - 0.1, yPos, {
          align: "right",
        });
        yPos += 0.35;
      }

      if (comisionTDC > 0) {
        doc.text("Comision TDC:", totalsX, yPos);
        doc.text(`$${comisionTDC.toFixed(2)}`, rightMargin - 0.1, yPos, {
          align: "right",
        });
        yPos += 0.35;
      }

      if (comisionFlete > 0) {
        doc.text("Flete:", totalsX, yPos);
        doc.text(`$${comisionFlete.toFixed(2)}`, rightMargin - 0.1, yPos, {
          align: "right",
        });
        yPos += 0.35;
      }

      // Separator line before total
      doc.setLineWidth(0.01);
      yPos += 0.25;

      // Total with emphasis
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);

      const totalLabelX = 3.5;
      doc.text("TOTAL:", totalLabelX, yPos);
      doc.text(`$${total_general_tabla.toFixed(2)}`, rightMargin - 0.1, yPos, {
        align: "right",
      });
      yPos += 0.4; // Space after monetary total

      // Add total pieces
      doc.text("TOTAL PIEZAS:", totalLabelX, yPos);
      doc.text(`${new Intl.NumberFormat("en-US").format(TK)}`, rightMargin - 0.1, yPos, {
        align: "right",
      });
      yPos += 0.8; // More space after pieces total

      // PAYMENT METHODS SECTION
      doc.setLineWidth(0.02);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.4;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text("FORMAS DE PAGO", centerX, yPos, { align: "center" });
      yPos += 0.5;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);

      // Only show payment methods that have values > 0
      if (efectivoTotal > 0) {
        doc.text(`Efectivo:`, leftMargin + 0.3, yPos);
        doc.text(`$${efectivoTotal.toFixed(2)}`, rightMargin - 0.1, yPos, {
          align: "right",
        });
        yPos += 0.35;
      }

      if (tdcTotal > 0) {
        doc.text(`TDC:`, leftMargin + 0.3, yPos);
        doc.text(`$${tdcTotal.toFixed(2)}`, rightMargin - 0.1, yPos, {
          align: "right",
        });
        yPos += 0.35;
      }

      if (transferTotal > 0) {
        doc.text(`Transfer:`, leftMargin + 0.3, yPos);
        doc.text(`$${transferTotal.toFixed(2)}`, rightMargin - 0.1, yPos, {
          align: "right",
        });
        yPos += 0.35;
      }

      // Show change if there is any
      const totalPagado = efectivoTotal + tdcTotal + transferTotal;
      const cambio = totalPagado - total_general_tabla;
      if (cambio > 0) {
        doc.text(`Cambio:`, leftMargin + 0.3, yPos);
        doc.text(`$${cambio.toFixed(2)}`, rightMargin - 0.1, yPos, {
          align: "right",
        });
        yPos += 0.35;
      }

      // If all payment methods are 0, show "Credito"
      if (efectivoTotal === 0 && tdcTotal === 0 && transferTotal === 0) {
        doc.text(`Credito`, centerX, yPos, { align: "center" });
        yPos += 0.35;
      }

      yPos += 0.5;

      // Add signature if needed
      if (condPago === "Credito") {
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);
        doc.text(`Firma: ________________`, leftMargin, yPos);
        yPos += 0.8;
      }

      // FOOTER with more spacing
      yPos += 0.3;
      doc.setLineWidth(0.01);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.4;

      // Store policies - centered
      doc.setFont("helvetica", "bold");
      doc.setFontSize(7);
      doc.text("POLÍTICAS DE LA TIENDA", centerX, yPos, {
        align: "center",
      });
      yPos += 0.5;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(6);

      const policies = [
        "**** NO ES UN COMPROBANTE FISCAL ****",
        "NO SE ACEPTAN CAMBIOS NI DEVOLUCIONES",
        "NI POR DEFECTO",
        "**** GRACIAS POR SU PREFERENCIA ****",
      ];

      policies.forEach((line) => {
        doc.text(line, centerX, yPos, { align: "center" });
        yPos += 0.25;
      });

      yPos += 0.4;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text("¡Gracias por su compra!", centerX, yPos, {
        align: "center",
      });
      yPos += 0.25;
      doc.text("Conserve este comprobante", centerX, yPos, {
        align: "center",
      });
      yPos += 0.4;

      // WhatsApp customer service info
      doc.setFont("helvetica", "bold");
      doc.setFontSize(6);
      doc.text("WhatsApp Atención a clientes:", centerX, yPos, {
        align: "center",
      });
      yPos += 0.25;
      doc.setFont("helvetica", "normal");
      doc.text("495 103 6208 & 495 101 1713", centerX, yPos, {
        align: "center",
      });
      yPos += 0.4;

      // QR code - properly centered
      const qrSize = 1.6;
      doc.addImage(img3, "png", centerX - qrSize / 2, yPos, qrSize, qrSize);

      // Save and print
      doc.autoPrint();
      window.open(doc.output("bloburl"), "_blank");

    } catch (error) {
      console.error("Error in PDFOC function:", error);
      Swal.fire({
        icon: "error",
        title: "Error generando PDF",
        text: "Hubo un problema al generar el PDF",
        footer: error.message,
      });
    }
  }



  const headers = [
    // { name: "Activo", field: "activo", sortable: true },
    { name: "Numero", field: "consecutivo", sortable: true },
    { name: "General", field: "numero", sortable: true },
    { name: "Tienda", field: "area", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Vendedor", field: "colaborador", sortable: true },
    { name: "Cantidad", field: "total_cantidad", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    { name: "Cond Pago", field: "condPago", sortable: true },
    { name: "Facturado", field: "facturado", sortable: true },
    { name: "Recibo", field: "recibo", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.facturado.toLowerCase().includes(search.toLowerCase()) ||
          comment.total_cantidad.toString().includes(search) ||
          comment.total_general.toString().includes(search) ||
          comment.consecutivo.toString().includes(search) ||
          comment.numero.toString().includes(search) ||
          comment.condPago.toLowerCase().includes(search.toLowerCase()) 
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
    if (selectedColaborador) {
      computedComments = computedComments.filter((e) =>
        e.idColaborador.includes(selectedColaborador)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
    if (selectedAreaFiltro) {
      computedComments = computedComments.filter((e) =>
        e.idAreas.includes(selectedAreaFiltro)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total_cantidad" &&
      sorting.field != "total_general" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "total_cantidad" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "total_cantidad" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedColaborador,
    selectedFechaInicio,
    selectedFechaFin,
    selectedAreaFiltro
  ]);

  function cancelarNota(idNota) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se cancelara la Nota!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cancelar!",
    }).then((result) => {
      if (result.isConfirmed) {
    axios
      .get(`${URL_VENTAS_TIENDAS}Cancel/${idNota}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(() => {
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
    }
  });
  }

    function desarrollo(){
      axios
        .get(
          `${URL_ARTICULOS_VENTAS_TIENDAS}Analisis`,
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )      
        .then((res) => {
         let array = res.data

            let dataExcel = array.map((a) => {
            if(a.diferencia != 0 && a.ventaActiva == "Si"){
                return {
                  Numero: a.numero,
                  Fecha: a.fecha,
                  Id: a.id,
                  Total: a.total,
                  Cantidad: a.cantidad,
                  Diferencia: a.diferencia,
                  VentaActiva: a.ventaActiva
                };}
            });
            const dataExportExcel = Object.values(dataExcel);
            const dataExcelLimpia = dataExportExcel.filter(function (el) {
              return el != null;
            });
        
            var option = {};
        
            option.fileName = "ListadoVentas";
        
            option.datas = [
              {
                sheetData: dataExcelLimpia,
                sheetName: "ListadoVentas",
                sheetFilter: [
                  "Numero",
                  "Fecha",
                  "Id",
                  "Total",
                  "Cantidad",
                  "Diferencia",
                  "VentaActiva",
                ],
                sheetHeader: [
                  "Numero",
                  "Fecha",
                  "Id",
                  "Total",
                  "Cantidad",
                  "Diferencia",
                  "VentaActiva",
                ],
              },
            ];
        
            var toExcel = new ExportJsonExcel(option);
            toExcel.saveExcel();
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
          });
          console.log(error);
        });
  }
  let totalCant = 0
  let totalGen = 0

  return (
    <>
      <Header />
      <br />
      <br />
      {user.listadoVentasTiendas ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.ventasTiendas ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/VentasTiendasCreate"
                >
                  Nuevo Venta
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nuevo Venta
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuTiendas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  // onClick={desarrollo}
                  onClick={PDFTabla}
                >
                  PDF <i className="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i className="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i className="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Ventas</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Reporte de Ventas</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>

          
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedAreaFiltro}
                onChange={(e) => {
                  setSelectedAreaFiltro(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {areas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
              </td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {clientes
                  .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedColaborador}
                onChange={(e) => {
                  setSelectedColaborador(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona un Vendedor</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
              </td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                  if(a.activo == "Si"){
                    totalCant = totalCant + a.total_cantidad
                    totalGen = totalGen + a.total_general
                  return (
                    <tr>
                      {/* <td>{a.activo}</td> */}
                      <td>{a.consecutivo}</td>
                      <td>{a.numero}</td>
                      <td>{a.area}</td>
                      <td>{fmtFecha(a.fecha)}</td>
                      <td>{a.clientes}</td>
                      <td>{a.colaborador}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.total_cantidad)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general)}</td>
                      <td>{a.condPago}</td>
                      <td>{a.facturado}</td>
                      <td>
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.fecha,
                                  a.fechaHora,
                                  a.colaborador,
                                  a.clientes,
                                  a.consecutivo,
                                  a._id,
                                  a.comisionTDC,
                                  a.comisionFlete,
                                  a.impuestos,
                                  a.areaSurtido,
                                  a.descuento,
                                  a.descuentoNumero,
                                  a.condPago,
                                  a.idAreas,

                                  // a.total_cantidad,
                                  // a.total_general,
                                  // a.observaciones,
                                  // a.numero,
                                  // a.paqueteria,
                                  // a.calle,
                                  // a.numero_ext,
                                  // a.numero_int,
                                  // a.pais,
                                  // a.estado,
                                  // a.ciudad,
                                  // a.delegacion,
                                  // a.colonia,
                                  // a.cp,
                                )
                              }
                            >
                              <i className="far fa-file-pdf"></i>
                            </Button>
                            {user.ventasTiendasCancel?(
                              
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) => cancelarNota(a._id)}
                            >
                              <i className="fas fa-ban"></i>
                            </Button>
                            ):undefined}
                      </td>
                    
                    </tr>
                  );
                }else{
                  return (
                    <tr className="row-cancelled">
                      <td>{a.consecutivo}</td>
                      <td>{a.numero}</td>
                      <td>{a.area}</td>
                      <td>{fmtFecha(a.fecha)}</td>
                      <td>{a.clientes}</td>
                      <td>{a.colaborador}</td>
                      <td></td>
                      <td></td>
                      <td>CANCELADA </td>
                      <td></td>
                      <td>  <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.fecha,
                                  a.fechaHora,
                                  a.colaborador,
                                  a.clientes,
                                  a.consecutivo,
                                  a._id,
                                  a.comisionTDC,
                                  a.comisionFlete,
                                  a.impuestos,
                                  a.areaSurtido,
                                  a.descuento,
                                  a.descuentoNumero,
                                  a.condPago,
                                  a.idAreas,

                                  // a.total_cantidad,
                                  // a.total_general,
                                  // a.observaciones,
                                  // a.numero,
                                  // a.paqueteria,
                                  // a.calle,
                                  // a.numero_ext,
                                  // a.numero_int,
                                  // a.pais,
                                  // a.estado,
                                  // a.ciudad,
                                  // a.delegacion,
                                  // a.colonia,
                                  // a.cp,
                                )
                              }
                            >
                              <i className="far fa-file-pdf"></i>
                            </Button></td>
                  </tr>
                  )
                }
              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="right">
                  TOTALES
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalCant)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalGen)}
                </td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

     
      {loader}
    </>
  );
}

export default ListadoVentasTiendas;
